module.exports = __webpack_public_path__ + "a25c8a97c733927b5b60c31830947b13.pdf";